import React from 'react'

const ApolloContext = React.createContext(null)

export default ApolloContext
